import { useMutation } from 'react-query';
import qs from 'qs';
import { network } from 'services/network';

const mutationFn = (params: RefreshProgramAnalysisData) => {
    const querystring = qs.stringify(
        { projectIDs: params.projectIDs, contractId: params.contractId },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/refreshProgramAnalysisData${querystring}`;
    return network.post(url).then((response) => response.data);
};
export const useMutationRefreshProgramAnalysisData = () => {
    return useMutation<any, QueryError, RefreshProgramAnalysisData>({ mutationFn: (params) => mutationFn(params) });
};

interface RefreshProgramAnalysisData {
    projectIDs?: number[];
    contractId?: number;
}
